import { BomLineType, BomPartType } from 'bom/enums';
import { IBomPart } from 'bom/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';

export const BomPartCellHelper = {
  getManufacturerName: (bomPart: IBomPart) => {
    if (!bomPart) {
      return null;
    }

    if (BomPartType.COMPONENT === bomPart.type) {
      return bomPart.manufacturerName;
    }

    return bomPart.partArr?.manufacturerName;
  },

  getDescription: (bomPart: IBomPart): string => {
    if (!bomPart) {
      return '';
    }

    if (BomPartType.COMPONENT === bomPart.type) {
      return bomPart.componentName;
    }

    return bomPart.partArr?.descriptionLong || bomPart.partArr?.description || '';
  },

  getLineType: (bomPart: IBomPart) => {
    if (!bomPart) {
      return null;
    }

    if (bomPart.partArr?.wildcard) {
      return BomLineType.WILDCARD;
    }

    if (bomPart.partArr?.verified) {
      return BomLineType.VERIFIED;
    }

    return BomLineType.UNVERIFIED;
  },

  getAlias: (bomPart?: IBomPart): string | undefined => {
    if (!bomPart) {
      return null;
    }

    const { orderingNumber, engineeringNumber } = bomPart.partArr || {};

    if (!orderingNumber && !engineeringNumber) {
      return null;
    }

    return `${orderingNumber || DEFAULT_PLACEHOLDER} ${engineeringNumber || DEFAULT_PLACEHOLDER}`;
  },
};
